import { type AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from "@angular/core";
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: "medsurf-node-tree-modal",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./node-tree-modal.component.html",
    styleUrls: ["./node-tree-modal.component.scss"],
    standalone: false
})
export class NodeTreeModalComponent implements AfterViewInit {
  @ViewChild('template_node_tree_scroll_panel', {static: false}) templateNodeTreeScrollPanel: ElementRef<HTMLDivElement>;
  
  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      const currentNode = this.slideAuthorFacade.snapshot_currentSelectedNode();
      if (!currentNode) return;
      const element = document.getElementById('tnt-' + currentNode.id);
      if (!element || !this.templateNodeTreeScrollPanel) return;
      this.templateNodeTreeScrollPanel.nativeElement.scrollTop = element.offsetTop - element.offsetHeight * 3;
    }, 200);
  }
}